import { formatPrice, imgClipPlan } from '@common/utils'

export default {
  methods: {
    formatPrice,
    imgClipPlan
  }
}
